import React from 'react';
import { cn } from '@/lib/utils';

import PropTypes from 'prop-types';

const fieldErrorListTemplate = errors => {
  if (!errors || !errors.length) return null;

  return (
    <ul className="error-list">
      {errors.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </ul>
  );
};

const fieldIsBool = (schm, uischm) =>
  (schm && schm.type === 'boolean') || (uischm && ['radio', 'checkbox'].includes(`${uischm['ui:widget']}`));

const FieldTemplate = ({
  id,
  label,
  children,
  displayLabel,
  required,
  rawErrors = [],
  rawDescription,
  schema,
  uiSchema,
  classNames,
}) => (
  <div className={cn('field', classNames, required && 'is-required')}>
    {displayLabel && label && (
      <label htmlFor={fieldIsBool(schema, uiSchema) ? null : id}>{label}</label>
    )}

    {children}

    {fieldErrorListTemplate(rawErrors)}

    {rawDescription && <div className="helper">{rawDescription}</div>}
  </div>
);

FieldTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  rawDescription: PropTypes.string,
  rawErrors: PropTypes.array,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  required: PropTypes.bool,
};

FieldTemplate.defaultProps = {
  label: null,
  rawDescription: null,
  rawErrors: [],
  required: false,
};

export default FieldTemplate;
